<script setup lang="ts">

const height = defineModel<number>( 'size', { default: 40 } );

</script>

<template>
    <div>
        <img class="opacity-1 dark:opacity-0" src="@/assets/images/carbucks.png" :style="{height: height+ 'px'}" />
        <img class="absolute top-0 opacity-0 dark:opacity-100" src="@/assets/images/carbucks-dark-mode.png" :style="{height: height+ 'px'}" />
    </div> 
</template>
